import { useId } from "react";
import { cn } from "@/lib/utils";

// Official XAU Pro Academy mark: gold X on a dark plate (same as favicon, X profile and Telegram bot).
export function BrandMark({ className }: { className?: string }) {
  const id = useId().replace(/:/g, "");
  return (
    <svg viewBox="0 0 64 64" className={cn("h-9 w-9 shrink-0", className)} role="img" aria-label="XAU Pro Academy logo">
      <defs>
        <linearGradient id={`g${id}`} x1="14" y1="14" x2="50" y2="50" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#FBD984" />
          <stop offset="45%" stopColor="#E8B636" />
          <stop offset="100%" stopColor="#9A7012" />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="31" fill="#0B0F1A" stroke="#E8B636" strokeOpacity="0.35" strokeWidth="1.5" />
      <g fill={`url(#g${id})`}>
        <path d="M13.53 18.47 L29.17 34.83 L45.53 50.47 L50.47 45.53 L34.83 29.17 L18.47 13.53 Z" />
        <path d="M45.53 13.53 L29.17 29.17 L13.53 45.53 L18.47 50.47 L34.83 34.83 L50.47 18.47 Z" />
      </g>
    </svg>
  );
}
